import { Button, type ButtonProps, Text } from "@pamperedchef/design-system";
import { className as classNameHelper } from "@/app/utilities/className";

import * as styles from "./PartyList.module.scss";

export interface PartyItemProps {
	hostName: string;
	location?: string;
	date?: string;
	cta?: ButtonProps;
	isLastElement?: boolean;
	onSelect?: (id: string) => void;
	showPk: string;
}

/**
 * PartyItem Component
 */
export function PartyItem({
	hostName,
	location,
	date,
	cta,
	isLastElement,
	onSelect,
	showPk
}: PartyItemProps): JSX.Element {
	return (
		<li
			{...classNameHelper(styles["party-list__item"], {
				[styles["party-list__item--last"]]: !!isLastElement
			})}
		>
			<div>
				<Text styledAs="h5" tag="h4">
					{hostName}
				</Text>
				<Text styledAs="sml">
					{location || "-"} | {date || "-"}
				</Text>
			</div>

			{cta && (
				<Button
					{...cta}
					kind="tertiary"
					size="lg"
					surface="default"
					onClick={() => onSelect?.(showPk)}
				/>
			)}
		</li>
	);
}
